import randomString from 'random-string';

/**
 * Generates a random peer name
 * @return {string}
 */
export default () => randomString({ length: 8 }).toLowerCase();
